export const COUPON_PERMISSION = {
  ADD: 'SM_COUPON_ADD',
  EDIT: 'SM_COUPON_EDIT',
  VIEW: 'SM_COUPON_VIEW',
  DEL: 'SM_COUPON_DEL',

  SELECT_RS_ERROR: 'SM_COUPON_SELECT_RS_ERROR',
  SELECT_CUSTOMER_TYPE: 'SM_COUPON_SELECT_CUSTOMER_TYPE',
};

export const KEY_FORM_COUPON = {
  INFORMATION: 'INFORMATION',
  ERROR_APPLY: 'ERROR_APPLY',
  CUSTOMER_TYPE_APPLY: 'CUSTOMER_TYPE_APPLY',
  COUPON_VALUE: 'COUPON_VALUE',
  COUPON_STATUS: 'COUPON_STATUS',
  COUPON_PRODUCT: 'COUPON_PRODUCT',
};

export const TYPO_TITLE_FORM = {
  INFORMATION: 'Thông tin mã khuyến mãi',
  ERROR_APPLY: 'Lỗi máy áp dụng',
  CUSTOMER_TYPE_APPLY: 'Áp dụng cho loại khách hàng',
  COUPON_VALUE: 'Giá trị khuyến mãi',
  COUPON_PRODUCT: 'Danh sách sản phẩm tặng kèm',
  COUPON_STATUS: 'Trạng thái',
};

export const TYPE_PROMOTION_VALUE = {
  MONEY: 1, // theo đ
  PERCENT: 2, // theo %
};

export const TYPE_ERROR = {
  ISAPPOINTERROR: 1,
  ISANYERROR: 2,
};

export const COUPON_TYPES = {
  PENDING: 1, // chưa áp dụng
  APPLYING: 2, // đang áp dụng
  EXPIRED: 3, // hết hạn
};

export const PANEL_TYPES = {
  INFORMATION: 'INFORMATION',
  LIST_COUPON: 'LIST_COUPON',
};
